import  Glightbox from 'glightbox';
let lightbox
setTimeout(function (){
     lightbox = Glightbox();
}, 1000)


